import React from 'react'
import { Icon, Tooltip } from 'gu-ui-kit'
import styles from 'modules/Services/CampaignsEditor/campaigns-editor.module.scss'
import PropTypes from 'prop-types'

const HeaderWithTooltip = ({ title, tooltipText }) => {
  return (
    <>
      {title}

      <Tooltip
        placement={'bottom'}
        className={styles['tooltip-icon-container']}
        title={tooltipText}
      >
        <Icon
          width={20}
          name={'information'}
          size={'m'}
          color={'Interface-Seventh'}
        />
      </Tooltip>
    </>
  )
}

HeaderWithTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  tooltipText: PropTypes.string,
}

export default HeaderWithTooltip
